import ChartModal from './ChartModal';

export default ChartModal;
